module.exports = __webpack_public_path__ + "img/IEC13751.f87353cf.png";